// DO NOT EDIT manually
// This file has edited by setConfig.sh file

// version : web version (from package.json)
// build time : time the build was performed
// build commit : Commit value of GIT

export default {
    version: '1.5.9',
    build_time: '2026-03-31T00:33:59',
    build_commit_hash: '57bc60a79d37d5060be877b8bd6d68d97401d218',
};
